import { Formik, Form,Field, ErrorMessage } from 'formik';
import { useParams } from 'react-router-dom';
import config from "src/config";
import FormikInput from 'src/components/formik/FormikInput';
import FormikTextarea from 'src/components/formik/FormikTextarea';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { postRequest } from 'src/utils/RequestUtil';
import { clientProductionSearchAction } from './actions/ClientProductionActions';
import { toast } from 'react-toastify';
import { useCallback, useEffect, useRef, useState } from "react";
import { ClientProductionDefaultProps, ClientProductionYupSchema } from "./ClientProductionPropTypes";
import { productionFIleRemoveAPI, userProductionFileAPI } from "src/api/ProductionApi";
import { getProjectForClientDeliveryFromAPI } from 'src/api/ClientProductionApi';
import { productionProjectAssigneeSearchAction } from 'src/containers/production-container/actions/ProductionActions';
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import ClientDeliveryBreadCrumbs from './DeliveryTree/ClientDeliveryBreadCrumbs';
import ProjectTree from './DeliveryTree/ProjectsTree';
import AddCategory from './DeliveryTree/AddCategory';


const Render = (props) => {
  // if (!isProduction()) {
  //   withFormikDevtools(props);
  // }
  const {
    files,
    showModal,
    handleRemoveFile, 
    handleUploadFile, 
    isSubmitting ,
    isValid, 
    dirty,
    setFieldValue,
    values
  } = props;
    const dateInputRef = useRef(null);  // Create a ref for the input  
    useEffect(() => {
      // Initialize flatpickr and disable time picker
      flatpickr(dateInputRef.current, {
        enableTime: false,  // Disable time picker
        dateFormat: "Y/m/d",  // Date format MM/DD/YYYY
        onChange: (selectedDates, dateStr) => {
          if (selectedDates.length > 0) {
            const selectedDate = selectedDates[0];
              const date = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;
              setFieldValue('date', date);
        }
      }
      });
    }, []);


  return (
    <>
    <Form autoComplete="disabled">
             
            <ProjectTree showModal={showModal}  />
            <ClientDeliveryBreadCrumbs/>

              <div className="row mt-16">
                <div className="col-md-4 mb-20">
                  <label className="form-label fw-semibold text-primary-light text-sm mb-8">Date</label>
                  <div className="position-relative">                     
                    {/* <input
                      className="form-control radius-8 bg-base"
                      id="editstartDate"
                      type="text"
                      placeholder="MM/DD/YYYY"
                      ref={dateInputRef}  // Attach ref to the input
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}  // This is optional but can help with manual input
                    />
                    <ErrorMessage
                    component="div"
                    className="text-danger"                    
                    /> */}
                      <Field
                        className="form-control radius-8 bg-base"
                        id="editstartDate"
                        type="text"
                        name="date" // Link to Formik state using 'name'
                        placeholder="MM/DD/YYYY"
                        innerRef={dateInputRef}  // Attach ref to the input using innerRef
                        onChange={(e) => setFieldValue('date', e.target.value)}  // Manually update the value
                      />
                      <ErrorMessage
                        name="date" // Link ErrorMessage to the 'startDate' field
                        component="div"
                        className="text-danger"
                      />
                    <span className="position-absolute end-0 top-50 translate-middle-y me-12 line-height-1">
                      <iconify-icon icon="solar:calendar-linear" className="icon text-lg"></iconify-icon>
                    </span>
                  </div>
                </div>
                <div className="col-md-4 mb-20">
                  <div className="produComment">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">Number*</label>
                    <div className="proTaskSec my-0 flex-column">
                    <FormikInput
                      type="number"
                      name="totalDurations"
                      className="form-control"
                      placeholder={0}
                    />
                      {/* <input type="number" placeholder={0} className="form-control" /> */}
                      {/* <span className="proTimeContent">min</span> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-20">
                  <div className="produComment w-100">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8 d-block">Attach (.zip file only)</label>

                    <div className="attchProMaine d-inline-block mt-0">
                      <input
                        type="file"
                        name="file"
                        id="file" className="from-control"
                        multiple
                        accept=".zip"  // Only allows ZIP files
                        onChange={handleUploadFile}
                      />
                      <label htmlFor="file">
                        <div className="attContent">+ Attachment {" "}
                          <span>
                            <svg
                              width={16}
                              height={16}
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14.4888 6.85102L8.16811 13.1709C7.4703 13.8935 6.52074 14.3192 5.51701 14.3595C4.51328 14.3997 3.53268 14.0514 2.77923 13.387C2.41132 13.0406 2.11674 12.6238 1.91297 12.1614C1.70921 11.699 1.6004 11.2004 1.59302 10.6951C1.58563 10.1898 1.67982 9.68821 1.86999 9.22003C2.06016 8.75186 2.34244 8.32665 2.70007 7.96964L8.0834 2.58631C8.50784 2.17421 9.07738 1.94564 9.66896 1.95001C10.2605 1.95437 10.8266 2.19131 11.245 2.60962C11.6633 3.02794 11.9002 3.59405 11.9046 4.18563C11.9089 4.7772 11.6804 5.34674 11.2683 5.77119L5.88494 11.1545C5.74607 11.2864 5.56187 11.3599 5.37036 11.3599C5.17885 11.3599 4.99465 11.2864 4.85578 11.1545C4.72041 11.0175 4.6445 10.8326 4.6445 10.6399C4.6445 10.4473 4.72041 10.2624 4.85578 10.1254L9.16007 5.82106C9.30872 5.67157 9.3919 5.46914 9.39131 5.25832C9.39071 5.0475 9.3064 4.84555 9.1569 4.69689C9.00741 4.54824 8.80499 4.46506 8.59416 4.46565C8.38334 4.46625 8.18139 4.55057 8.03273 4.70006L3.72844 9.00277C3.29543 9.43712 3.05228 10.0254 3.05228 10.6387C3.05228 11.2521 3.29543 11.8404 3.72844 12.2747C4.16908 12.6954 4.75484 12.9301 5.36403 12.9301C5.97321 12.9301 6.55897 12.6954 6.99961 12.2747L12.3829 6.89139C12.745 6.5364 13.033 6.11315 13.2304 5.64613C13.4278 5.17911 13.5307 4.67759 13.533 4.17057C13.5354 3.66355 13.4372 3.16109 13.2441 2.69226C13.0511 2.22342 12.767 1.79752 12.4083 1.43918C12.0495 1.08084 11.6234 0.797178 11.1543 0.604594C10.6853 0.41201 10.1827 0.314329 9.67572 0.3172C9.1687 0.320072 8.66728 0.423439 8.20046 0.621323C7.73364 0.819207 7.31069 1.10768 6.95607 1.47006L1.57273 6.85339C1.06542 7.36045 0.665137 7.96425 0.395625 8.62896C0.126113 9.29366 -0.00713247 10.0057 0.00379549 10.7229C0.0147234 11.4401 0.169602 12.1478 0.459241 12.804C0.74888 13.4602 1.16738 14.0515 1.6899 14.5429C2.67042 15.4541 3.96298 15.9547 5.30148 15.9417C6.79668 15.9413 8.23048 15.347 9.28753 14.2895L15.6082 7.96885C15.6838 7.89582 15.7441 7.80847 15.7856 7.71188C15.8271 7.61529 15.8489 7.51141 15.8499 7.40629C15.8508 7.30118 15.8307 7.19693 15.7909 7.09964C15.7511 7.00234 15.6923 6.91395 15.618 6.83962C15.5437 6.76529 15.4553 6.70651 15.358 6.6667C15.2607 6.6269 15.1565 6.60686 15.0513 6.60778C14.9462 6.60869 14.8423 6.63053 14.7457 6.67202C14.6492 6.71351 14.5618 6.77382 14.4888 6.84943V6.85102Z"
                                fill="#CC33FF"
                              />
                            </svg></span></div>
                      </label>
                    </div>
                  </div>

                </div>
              </div>

              <div className="d-block w-100">
                {/* Display File Info Section */}
                {files.length > 0 &&
                  files.map((file, index) => (
                    <div className="clientDocShow clientDocShowNeFile my-4" key={index}>
                      <div className="cleDocContent">
                        <div className="d-flex align-items-start gap-1">
                          <div className="fileFormat">
                            <span className="bgFilesg">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="40"
                                fill="currentColor"
                                className="bi bi-file-earmark-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m5.5 1.5v2a1 1 0 0 0 1 1h2z"></path>
                              </svg>
                            </span>
                            <span className="filefmttext">ZIP</span>
                          </div>
                          <div>
                            <div className="FileName">{file.name}</div>
                            <div className="FileSize">
                              {(file.size / 1024).toFixed(2)} KB
                            </div>
                          </div>
                        </div>
                        <button
                          className="deletFilebtn px-3 py-3 d-flex justify-content-center align-items-center"
                          onClick={() => handleRemoveFile(file)}
                        >
                          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.30775 17.4997C2.81058 17.4997 2.385 17.3227 2.031 16.9687C1.677 16.6147 1.5 16.1892 1.5 15.692V2.99973H1.25C1.0375 2.99973 0.859417 2.92782 0.71575 2.78398C0.571917 2.64015 0.5 2.46198 0.5 2.24948C0.5 2.03682 0.571917 1.85873 0.71575 1.71523C0.859417 1.57157 1.0375 1.49973 1.25 1.49973H5C5 1.2549 5.08625 1.04624 5.25875 0.873735C5.43108 0.701402 5.63967 0.615234 5.8845 0.615234H10.1155C10.3603 0.615234 10.5689 0.701402 10.7413 0.873735C10.9138 1.04624 11 1.2549 11 1.49973H14.75C14.9625 1.49973 15.1406 1.57165 15.2843 1.71548C15.4281 1.85932 15.5 2.03748 15.5 2.24998C15.5 2.46265 15.4281 2.64073 15.2843 2.78423C15.1406 2.9279 14.9625 2.99973 14.75 2.99973H14.5V15.692C14.5 16.1892 14.323 16.6147 13.969 16.9687C13.615 17.3227 13.1894 17.4997 12.6923 17.4997H3.30775ZM13 2.99973H3V15.692C3 15.7818 3.02883 15.8556 3.0865 15.9132C3.14417 15.9709 3.21792 15.9997 3.30775 15.9997H12.6923C12.7821 15.9997 12.8558 15.9709 12.9135 15.9132C12.9712 15.8556 13 15.7818 13 15.692V2.99973ZM6.15425 13.9997C6.36675 13.9997 6.54483 13.9279 6.6885 13.7842C6.832 13.6404 6.90375 13.4622 6.90375 13.2497V5.74973C6.90375 5.53723 6.83183 5.35907 6.688 5.21523C6.54433 5.07157 6.36617 4.99973 6.1535 4.99973C5.941 4.99973 5.76292 5.07157 5.61925 5.21523C5.47575 5.35907 5.404 5.53723 5.404 5.74973V13.2497C5.404 13.4622 5.47583 13.6404 5.6195 13.7842C5.76333 13.9279 5.94158 13.9997 6.15425 13.9997ZM9.8465 13.9997C10.059 13.9997 10.2371 13.9279 10.3807 13.7842C10.5243 13.6404 10.596 13.4622 10.596 13.2497V5.74973C10.596 5.53723 10.5242 5.35907 10.3805 5.21523C10.2367 5.07157 10.0584 4.99973 9.84575 4.99973C9.63325 4.99973 9.45517 5.07157 9.3115 5.21523C9.168 5.35907 9.09625 5.53723 9.09625 5.74973V13.2497C9.09625 13.4622 9.16817 13.6404 9.312 13.7842C9.45567 13.9279 9.63383 13.9997 9.8465 13.9997Z" fill="#1C1B1F"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="produComment">
                <label className="form-label fw-semibold text-primary-light text-sm mb-8">Comment*</label>
                {/* <textarea
                  className="form-control"
                  id=""
                  placeholder="Write your comment here..."
                  defaultValue={""}
                /> */}
                  <FormikTextarea
                    name="comment"
                    className="form-control"
                    rows={4}
                    cols={50}
                    placeholder="Write comment here..."
                    defaultValue={""}
                  />
              </div>
              <div className='py-16 psstyky bg-white z-9'>
              <button  type="submit" 
              className="btn btn-primary w-100 mt-16" 
              data-bs-dismiss="modal"
              aria-label="Close"
              disabled={!isValid || !dirty || isSubmitting}
              >
                Submit{" "}
              </button>
              </div>
       </Form>
    </>
  );
};
const AddClientDelivery = ({search}) => {
  const { projectId } = useParams();
  // Function to format the date
  const { _id: userId } = useSelector(state => state.auth?.user, shallowEqual);
  const {currentRecord} = useSelector((state) => state.ProjectReducer,shallowEqual)
  const {selectCategory,selectSubCategory} = useSelector(state => state.ClientProductionReducer,shallowEqual)


  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState([])
  const [categoryId, setCategoryId] = useState(null)

  const handleSubmit = useCallback(async (values, { setSubmitting, resetForm }) => {
    setIsLoading(true);
    try {
      const productionSlugParts = [
        currentRecord?.RefClientId?.ClientProjectCode,  // Check for ClientProjectCode
        currentRecord?.ProjectSubCode,                 // Check for ProjectSubCode
        selectCategory?.categoryName,                  // Check for categoryName
        selectSubCategory?.subCategoryName             // Check for subCategoryName
      ];

      values.userId = userId
      values.clientId = currentRecord.RefClientId?._id
      values.projectId = currentRecord._id      
      values.categoryId = selectCategory.categoryId
      values.subCategoryId = selectSubCategory.subCategoryId
      values.files = files
      values.productionSlug = productionSlugParts.filter(Boolean).join('>');
      const url = `${config.baseUrl}clientProduction/save`;
      const result = await postRequest({
        url,
        data: values,
      });
      search()
      // dispatch(clientProductionSearchAction())
      toast.success('Production submitted successfully!');
      resetForm(); // Reset the form after successful submission
    } catch (error) {
      toast.error('Failed to submit form! ' + error.message);
    } finally {
      setSubmitting(false);
      setIsLoading(false);
    }
  }, [
    files,
    currentRecord?._id,
    currentRecord?.RefClientId?._id,
    selectCategory.categoryId,
    selectSubCategory.subCategoryId,
    userId,
  ]);

  const handleUploadFile = async (event) => {
    const files = event.target.files;
    const payload = { file: files[0], by: userId };
    const fileResponse = await userProductionFileAPI(payload);
    setFiles(prevFiles => [...prevFiles, fileResponse.data.data]);
  };

  const handleRemoveFile = async (data) => {
    const remove = await productionFIleRemoveAPI({ ids: [data._id] })
    if (remove)
      setFiles(files.filter(item => item._id !== data._id))
  }

  const loadProjectIntoTree = async (projectId) => {
    const projects = await getProjectForClientDeliveryFromAPI(projectId)
    dispatch(productionProjectAssigneeSearchAction({
      data: projects.data.data
    }));
  }

  useEffect(() => {
    loadProjectIntoTree(projectId);
  }, [projectId]);

  useEffect(() => {
    // Initialize Bootstrap tooltips for elements with data-bs-toggle="tooltip"
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

    // Cleanup tooltips when the component unmounts
    return () => {
      tooltipList.forEach(tooltip => tooltip.dispose());
    };
  }, []);

  const [categories, setCategories] = useState(['']); // Initialize with one input field

  const addCategory = () => {
    setCategories([...categories, '']); // Add a new empty input field
  };

  const removeCategory = (indexToRemove) => {
    const newCategories = categories.filter((_, index) => index !== indexToRemove); // Remove the selected input
    setCategories(newCategories);
  };


  // State to manage the visibility of the div
  const [isModalVisible, setModalVisible] = useState(false);

  // Handler to show the modal (remove d-none class)
  const showModal = (categoriesId=null) => {
    setCategoryId(categoriesId)
    setModalVisible(true);
  };

  // Handler to hide the modal (add d-none class)
  const hideModal = () => {
    setModalVisible(false);
  };



  return (
    <>
      {/* <div
        className="modal fade producSecMAin"
        id="addClientDelivery"
        tabIndex={-1}
        aria-labelledby="addClientDeliverySec"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title" id="addClientDeliverySec">
                Add Client Delivery
              </h1>
              <button
                type="button"
                className=""
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  width={33}
                  height={33}
                  viewBox="0 0 33 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.2813 12.4069L18.1304 16.5L22.2813 20.5931C22.3968 20.7013 22.4889 20.832 22.5519 20.9772C22.6148 21.1224 22.6473 21.2789 22.6473 21.4372C22.6473 21.5954 22.6148 21.752 22.5519 21.8972C22.4889 22.0424 22.3968 22.1731 22.2813 22.2813C22.1733 22.3884 22.0451 22.4732 21.9043 22.5307C21.7634 22.5883 21.6125 22.6175 21.4604 22.6166C21.157 22.6153 20.8664 22.4949 20.651 22.2813L16.5001 18.1303L12.4069 22.2813C12.1916 22.4949 11.9009 22.6153 11.5976 22.6166C11.4454 22.6175 11.2945 22.5883 11.1537 22.5307C11.0128 22.4732 10.8847 22.3884 10.7766 22.2813C10.5613 22.0646 10.4404 21.7716 10.4404 21.4661C10.4404 21.1606 10.5613 20.8676 10.7766 20.6509L14.8697 16.5L10.7766 12.4069C10.5872 12.1857 10.4882 11.9012 10.4994 11.6102C10.5107 11.3192 10.6313 11.0431 10.8372 10.8372C11.0432 10.6313 11.3192 10.5106 11.6102 10.4994C11.9012 10.4882 12.1857 10.5871 12.4069 10.7766L16.5001 14.8697L20.5932 10.7766C20.7002 10.6657 20.8281 10.5771 20.9694 10.5156C21.1107 10.4542 21.2627 10.4212 21.4168 10.4185C21.5709 10.4158 21.724 10.4435 21.8673 10.5C22.0107 10.5564 22.1416 10.6406 22.2524 10.7477C22.3632 10.8547 22.4519 10.9825 22.5134 11.1239C22.5748 11.2652 22.6078 11.4172 22.6105 11.5713C22.6132 11.7254 22.5855 11.8785 22.529 12.0218C22.4725 12.1652 22.3883 12.296 22.2813 12.4069ZM27.9469 27.9469C25.683 30.2106 22.7987 31.7521 19.6586 32.3766C16.5186 33.0011 13.2639 32.6804 10.3062 31.4551C7.34837 30.2299 4.82032 28.1551 3.04169 25.4931C1.26306 22.8311 0.313721 19.7015 0.313721 16.5C0.313721 13.2985 1.26306 10.1689 3.04169 7.50689C4.82032 4.8449 7.34837 2.77011 10.3062 1.54487C13.2639 0.319623 16.5186 -0.00103968 19.6586 0.623425C22.7987 1.24789 25.683 2.78943 27.9469 5.05313C29.4503 6.5563 30.6428 8.34087 31.4564 10.3049C32.27 12.269 32.6887 14.3741 32.6887 16.5C32.6887 18.6259 32.27 20.731 31.4564 22.6951C30.6428 24.6591 29.4503 26.4437 27.9469 27.9469ZM26.3166 6.68344C24.3742 4.74781 21.9019 3.43113 19.2117 2.89966C16.5215 2.36819 13.7342 2.64578 11.2017 3.69735C8.66918 4.74893 6.50505 6.52735 4.98257 8.80804C3.4601 11.0887 2.64756 13.7694 2.64756 16.5116C2.64756 19.2537 3.4601 21.9344 4.98257 24.2151C6.50505 26.4958 8.66918 28.2742 11.2017 29.3258C13.7342 30.3774 16.5215 30.6549 19.2117 30.1235C21.9019 29.592 24.3742 28.2753 26.3166 26.3397C27.6101 25.0507 28.6365 23.519 29.3368 21.8324C30.0371 20.1459 30.3976 18.3377 30.3976 16.5116C30.3976 14.6854 30.0371 12.8772 29.3368 11.1907C28.6365 9.50418 27.6101 7.97248 26.3166 6.68344Z"
                    fill="#323338"
                  />
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={ClientProductionDefaultProps}
                validationSchema={ClientProductionYupSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {(formikProps) => (
                  <Render
                    {...formikProps}
                    files={files}
                    handleUploadFile={handleUploadFile}
                    handleRemoveFile={handleRemoveFile}
                  />
                )}
              </Formik>
            </div> 
          </div>
        </div>
      </div> */}

      <div
        className="modal fade pcdModal producSecMAin cusmodl"
        id="addClientDelivery"
        tabIndex={-1}
        aria-labelledby="addClientDeliverySec"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title" id="addClientDeliverySec">
                Add Client Delivery
              </h1>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ✗
              </button>
            </div>
            <div className="modal-body pb-0">
            <Formik
                initialValues={ClientProductionDefaultProps}
                validationSchema={ClientProductionYupSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {(formikProps) => (
                  <Render
                    {...formikProps}
                    files={files}
                    showModal={showModal}
                    handleUploadFile={handleUploadFile}
                    handleRemoveFile={handleRemoveFile}
                  />
                )}
              </Formik>
            </div>

            {/* Add new popup  */}
            <AddCategory 
              isModalVisible={isModalVisible}
              categories={categories}
              setCategories={setCategories}
              addCategory={addCategory} 
              removeCategory={removeCategory}
              hideModal={hideModal}
              categoryId={categoryId}
            />
            

          </div>
        </div>
      </div>


    </>
  )
}

export default AddClientDelivery